const $ = require('jquery');

import picturefill from 'picturefill';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const hoshinoresorts = (() => {

	// 変数宣言
	const pointSP = window.matchMedia('screen and (max-width: 767px)');

	// このJSのinit
	function init() {
		smoothScroll();
		fadeNav();

		telLink();
		carousel();

		AOS.init({
			offset: 100,
			duration: 1200,
			once: true
		});
		onElementHeightChange(document.body, function(){
			AOS.refresh();
		  });
	}

	// 関数 ------------------------------------
	// 0.2秒毎に高さを確認してrefresh
	function onElementHeightChange(elm, callback) {
		var lastHeight = elm.clientHeight
		var newHeight;
		
		(function run() {
			newHeight = elm.clientHeight;      
			if (lastHeight !== newHeight) callback();
			lastHeight = newHeight;
	
			if (elm.onElementHeightChangeTimer) {
			  clearTimeout(elm.onElementHeightChangeTimer); 
			}
	
			elm.onElementHeightChangeTimer = setTimeout(run, 200);
		})();
	  }
	function smoothScroll() {
		$('a[href^="#"]').on('click.smoothScroll', (event) => {
			const speed = 1200;// ミリ秒
			const href = $(event.currentTarget).attr("href");
			const target = $(href == "#" || href == "" ? 'html' : href);
			const position = target.offset().top;
			$('html, body').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	}

	function fadeNav() {
		const $nav = $('.l-nav-utility');

		$(window).on('load scroll', function() {
			const scrollP = $(this).scrollTop(),
			      visualH = $('.p-visual-main').height();

			if (scrollP >= visualH){
				$nav.addClass('is-active');
			}
			else{
				$nav.removeClass('is-active');
			}
		});
	}

	function telLink() {
		const $tel = $('.js-tel');

		$tel.each((index, element) => {
			const $self = $(element);
			const str = $self.find('i').text();

			$self.attr('href', 'tel:' + str.replace(/-/g, ''));
		});
	}

	function carousel() {
		const swiper = new Swiper('.js-carousel', {
			autoplay: {
				delay: 5000,
			},
			centeredSlides: true,
			lazy: true,
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 30,
		});
	}
	// -----------------------------------------

	return {
		init : init
	};

})();

// このタイミングで実行
$(() => {
	hoshinoresorts.init();
});
